const DEFAULT_UTC_TIME = '09:00';

export function splitUtcDateTime(iso: string | null | undefined): { dateIso: string | null; time: string } {
  if (!iso?.trim()) {
    return { dateIso: null, time: DEFAULT_UTC_TIME };
  }

  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) {
    return { dateIso: null, time: DEFAULT_UTC_TIME };
  }

  const time = `${String(parsed.getUTCHours()).padStart(2, '0')}:${String(parsed.getUTCMinutes()).padStart(2, '0')}`;
  return { dateIso: parsed.toISOString(), time };
}

export function combineUtcDateAndTime(dateIso: string | null | undefined, time: string | null | undefined): string | null {
  if (!dateIso?.trim()) {
    return null;
  }

  const base = new Date(dateIso);
  if (Number.isNaN(base.getTime())) {
    return null;
  }

  const match = /^(\d{1,2}):(\d{2})$/.exec((time ?? DEFAULT_UTC_TIME).trim());
  const hours = match ? Number(match[1]) : 9;
  const minutes = match ? Number(match[2]) : 0;

  return new Date(Date.UTC(
    base.getUTCFullYear(),
    base.getUTCMonth(),
    base.getUTCDate(),
    hours,
    minutes,
    0,
    0
  )).toISOString();
}

export function defaultCalendarFromUtc(): string {
  return new Date(Date.now() - 7 * 86400000).toISOString();
}

export function defaultCalendarToUtc(): string {
  return new Date(Date.now() + 21 * 86400000).toISOString();
}
